const scaleReducer = (state = 100, action) => {
  switch (action.type) {
    case 'SET_SCALE':
      return action.value;
    default:
      return state;
  }
};

export default scaleReducer;
